import React, { useState, useEffect } from "react";
import styles from "./ABMListFondistaCompany.module.css";
import DownButtonCompany from "../DownButtonCompany/DownButtonCompany";
import axios from "axios";
import EditABMCompany from "../EditABMCompany/EditABMCompany";
import DownloadButtonCompany from "../DownloadButtonCompany/DownloadButtonCompany";
import CreateABMCompany from "../CreateABMCompany/CreateABMCompany";
import PrintButtonCompany from "../PrintButtonCompany/PrintButtonCompany";
import { TiDelete } from "react-icons/ti";
import { AiFillCheckCircle } from "react-icons/ai";

const AMBListFondistaCompany = ({
  data,
  displayList,
  setTypeDocument,
  setFileId,
  reloadChildData,
}) => {
  const [aMB, setAMB] = useState([]);
  const [documentDeletedId, setDocumentDeletedId] = useState(null);

  useEffect(() => {
    const userId = data.id;
    const apiUrl = `${process.env.REACT_APP_LEALTAD_ABM_OF_DOCUMENT_COMPANY_GET_ALL}?userId=${userId}`;

    const fetchData = async () => {
      try {
        const response = await axios.get(apiUrl);
        if (response.status === 204) {
          setAMB([]);
        } else {
          setAMB(response.data);
        }
      } catch (error) {}
    };

    fetchData();
  }, [data, reloadChildData, documentDeletedId]);

  const combinedValues = [
    {
      variable: "ESTATUTO - REFORMA ESTATUTARIA",
    },
    {
      variable: "ULTIMO BALANCE CERTIFICADO",
    },
    {
      variable: "DJ DE PERSONAS JURIDICAS",
    },
    {
      variable: "DJ ORIGEN Y LICITUD DE FONDOS PERSONA JURÍDICA",
    },
    {
      variable: "DJ DE AUTORIDADES VIGENTES",
    },
    {
      variable: "ACTA DE ASAMBLEA DE DESIGNACION DE AUTORIDADES VIGENTES",
    },
    {
      variable: "ACTA DE ORGANO DIRECTIVO DE DISTRIBUCION DE CARGOS",
    },
    {
      variable: "DNI DE AUTORIDADES VIGENTES",
    },
    {
      variable: "CONSTANCIA INSCRIPCION UIF (DE CORRESPONDER)",
    },
    {
      variable: "DJ PEP AUTORIDADES (134/2018)",
    },
    {
      variable:
        "DJ CUMPLIMIENTO NORMATIVAS UIF - OFICIAL DE CUMPLIMIENTO (DE CORRESPONDER)",
    },
    {
      variable: "CONSTANCIA INSCRIPCION UIF OFICIAL DE CUMPLIMIENTO",
    },
    {
      variable: "ACTA DE ASAMBLEA DESIGNACION OFICIAL DE CUMPLIMIENTO",
    },
    {
      variable:
        "ACTA DE ORGANO DIRECTIVO APROBACION MANUAL DE PROCEDIMIENTOS PLA/FT",
    },
    {
      variable: "COPIA DEL MANUAL DE PROCEDIMIENTOS PLA/FT",
    },
  ].map((item) => {
    // Resto del mapeo si no es un 404
    const matchingDocument = aMB.find(
      (doc) => doc.typeDocument === item.variable
    );

    if (matchingDocument) {
      return {
        id: matchingDocument.id,
        file: "Yes",
        estado: <AiFillCheckCircle style={{ color: "green" }} />,
        variable: item.variable,
        valorObtenido: matchingDocument.description,
        riesgoObtenido: `${
          matchingDocument.expiresAt === "1"
            ? "1 Mes"
            : matchingDocument.expiresAt + " Meses"
        }`,
      };
    } else {
      return {
        estado: <TiDelete style={{ color: "red" }} />,
        file: "No",
        variable: item.variable,
        valorObtenido: "-",
        riesgoObtenido: "-",
      };
    }
  });

  const OpenForm = (viewOrNot) => {
    displayList(viewOrNot);
  };

  return (
    <div className={styles.bodyMDRLealtad}>
      <>
        <table className={styles.tableMDRLealtad}>
          <thead>
            <tr>
              <th>Estado</th>
              <th>Tipo de archivo</th>
              <th>Descripcion</th>
              <th>Fecha de vencimiento</th>
              <th>Alta</th>
              <th>Baja</th>
              <th>Modificacion</th>
              <th>Descargar</th>
              <th>Imprimir</th>
            </tr>
          </thead>
          <tbody>
            {combinedValues.map((item, index) => (
              <tr key={index}>
                <td>{item.estado}</td>
                <td>{item.variable}</td>
                <td>{item.valorObtenido}</td>
                <td className={styles.numberSquareMDRLealtad}>
                  <div className={styles.numberContainerMDRLealtad}>
                    <p>{item.riesgoObtenido}</p>
                  </div>
                </td>
                <td>
                  {item.file === "No" ? (
                    <CreateABMCompany
                      setTypeDocument={setTypeDocument}
                      typeDocument={item.variable}
                      OpenForm={OpenForm}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <DownButtonCompany
                      id={item.id}
                      onDocumentDeleted={setDocumentDeletedId}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <EditABMCompany
                      setTypeDocument={setTypeDocument}
                      typeDocument={item.variable}
                      setFileId={setFileId}
                      id={item.id}
                      OpenForm={OpenForm}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <DownloadButtonCompany
                      id={item.id}
                      typeDocument={item.variable}
                    />
                  ) : (
                    <div></div>
                  )}
                </td>
                <td>
                  {item.file === "Yes" ? (
                    <PrintButtonCompany id={item.id} />
                  ) : (
                    <div></div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </>
    </div>
  );
};

export default AMBListFondistaCompany;
